var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "23px",
    viewBox: "0 0 18 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Combined Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "container/invoice_drag-drop-copy-12",
    transform: "translate(-316.000000, -17.000000)",
    fill: "#0091EA",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(316.000000, 17.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8,19.55 C13.3522847,19.55 13.8,19.9977153 13.8,20.55 L13.8,22 C13.8,22.5522847 13.3522847,23 12.8,23 L4.45,23 C3.89771525,23 3.45,22.5522847 3.45,22 L3.45,20.55 C3.45,19.9977153 3.89771525,19.55 4.45,19.55 L12.8,19.55 Z M8.62642422,3.95239397e-13 C9.09052251,3.95239397e-13 9.53523014,0.186142982 9.86094922,0.516739872 L9.86094922,0.516739872 L16.9437992,8.14353987 C17.2554931,8.47870592 17.3387591,8.96680018 17.155815,9.38634852 C16.972871,9.80589686 16.5585491,10.077018 16.1008492,10.0766899 L16.1008492,10.0766899 L12.3633492,10.0766899 C12.2045674,10.0766899 12.0758492,10.205408 12.0758492,10.3641899 L12.0758492,10.3641899 L12.0758492,16.0578399 C12.0758492,16.6929673 11.5609767,17.2078399 10.9258492,17.2078399 L10.9258492,17.2078399 L6.32584922,17.2078399 C5.69072176,17.2078399 5.17584922,16.6929673 5.17584922,16.0578399 L5.17584922,16.0578399 L5.17584922,10.3641899 C5.17584922,10.205408 5.04713108,10.0766899 4.88834922,10.0766899 L4.88834922,10.0766899 L1.15084922,10.0766899 C0.69314929,10.077018 0.27882746,9.80589686 0.0958834185,9.38634852 C-0.0870606228,8.96680018 -0.00379463036,8.47870592 0.307899219,8.14353987 L0.307899219,8.14353987 L7.39189922,0.516739872 C7.7176183,0.186142982 8.16232593,3.95239397e-13 8.62642422,3.95239397e-13 Z",
    id: "Combined-Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.5baf9b301463bd0cfd1e0889a6568f94.svg";
export { ForwardRef as ReactComponent };